module.exports = __webpack_public_path__ + "img/pic_zs_2@2x.8503cf4a.png";